import React from 'react';
import {makeStyles} from '@mui/styles';
import {Switch} from '@mui/material';

const SwitchButton = ({checked = false, onChange, className = ''}) => {
  const classes = useStyles();

  return (
    <Switch
      classes={classes}
      checked={checked}
      onChange={onChange}
      color={"primary"}
      className={className}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: 38,
    height: 22,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 20,
    height: 20,
  },
  track: {
    borderRadius: 22 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}));

export default SwitchButton